<template>
  <div v-if="!loading">
    <div class="flex justify-between">
      <h4 class="text-1lg">Invitations</h4>
      <button
        v-if="userHasManageUsers"
        class="text-1md text-yellow-500"
        @click="onOpenInvitationModal"
      >
        Invite New User +
      </button>
    </div>
    <div v-if="invitations.length">
      <div class="mt-4 max-w-lg rounded-md border border-light-gray">
        <div
          v-for="(invitation, index) in invitations"
          :key="invitation.id"
        >
          <invitation-card
            :invitation="invitation"
            :toggle-delete-modal-on="onOpenDeleteModal"
            :class="index !== invitations.length ? 'border-b' : ''"
            :dark-bg="index % 2 !== 0"
          />
        </div>
      </div>
    </div>
    <div
      v-else
      class="mt-6 rounded-md bg-off-white px-6 py-8"
    >
      <p class="notice-text">
        You currently do not have any pending invitations for users to join this
        account.
      </p>
    </div>
  </div>
  <div
    v-else
    class="tablet-desktop-container mx-auto flex h-80 max-w-2xl items-center justify-center pt-12 sm:overflow-scroll md:overflow-hidden"
  >
    <img
      class="-top-2px loading relative h-12 w-full"
      src="@/assets/loading-v2-yellow.svg"
      alt=""
    />
  </div>

  <user-invitation-modal
    v-if="invitationModalVisible"
    :visible="invitationModalVisible"
    type="accept"
    @invitation-sent="onCloseSentInvitationModal"
    @close="onCloseInvitationModal"
  />
  <confirm-delete-modal
    :visible="deleteModalVisible"
    subtext="Are you sure you want to delete this invitation?"
    @delete="handleDeleteInvitation"
    @close="onCloseDeleteModal"
  />
</template>

<script type="text/javascript">
import InvitationCard from '@/components/carrier/Cards/InvitationCard.vue';
import UserInvitationModal from '@/components/modals/UserInvitationModal.vue';
import ConfirmDeleteModal from '@/components/modals/ConfirmDeleteModal.vue';

export default {
  name: 'Invitations Mobile Index',
  components: {
    InvitationCard,
    UserInvitationModal,
    ConfirmDeleteModal,
  },
  data() {
    return {
      invitationModalVisible: false,
      deleteModalVisible: false,
      deleteInvitationId: '',
    };
  },
  computed: {
    userHasManageUsers() {
      return this.$store.state.users.currentUser.scopes.includes(
        'manage_users'
      );
    },
    invitations() {
      return this.$store.state.userInvitations.collection;
    },
    loading() {
      return this.$store.state.loading.isLoading;
    },
    empty() {
      return this.$store.state.loading.isEmpty;
    },
  },
  watch: {
    '$store.state.userInvitations.collection.length': function (val) {
      if (val > 0) {
        this.$store.commit('loading/emptyToggleOff', null, {
          root: true,
        });
      } else {
        this.$store.commit('loading/emptyToggleOn', null, {
          root: true,
        });
      }
    },
  },
  async created() {
    this.$store.commit('loading/loadingToggleOn', null, {
      root: true,
    });
    await this.$store.dispatch('userInvitations/getUserInvitations', {});
  },
  methods: {
    onOpenInvitationModal() {
      this.invitationModalVisible = true;
    },
    onCloseInvitationModal() {
      this.invitationModalVisible = false;
    },
    onCloseSentInvitationModal() {
      this.invitationModalVisible = false;
      this.$toast.open({
        message: 'Invite sent',
        type: 'success',
        duration: 5000,
        dismissible: true,
        position: 'top-right',
      });
    },
    onOpenDeleteModal(id) {
      this.deleteModalVisible = true;
      this.deleteInvitationId = id;
    },
    onCloseDeleteModal() {
      this.deleteModalVisible = false;
    },
    async handleDeleteInvitation() {
      await this.$store.dispatch(
        'userInvitations/destroyUserInvitation',
        this.deleteInvitationId
      );
      this.$toast.open({
        message: 'Invitation deleted',
        type: 'success',
        duration: 5000,
        dismissible: true,
        position: 'top-right',
      });
      this.onCloseDeleteModal();
    },
  },
};
</script>
<style scoped>
.notice-text {
  @apply text-center text-gray-over-dark;
  font-size: 16px;
}
</style>
